import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { InfoCard } from 'core/components';
import { IProjectDetails } from 'projects/types';

interface IProps {
  project: IProjectDetails;
}

export const MainInfo = ({ project }: IProps) => {
  const { t } = useTranslation();

  const items = useMemo(() => {
    return [
      {
        label: t('labelProjectName'),
        value: project.name,
      },
    ];
  }, [project.name, t]);

  return <InfoCard title={t('titleMainInfo')} items={items} />;
};
